import Raven from 'raven-js';
// @ts-expect-error Untyped module
import { setupCsat } from 'wootric-nps/csat/csat-setup';
const triggerWootricSurvey = surveyName => {
  try {
    setupCsat(surveyName);
  } catch (error) {
    Raven.captureException(error, {
      extra: {
        from: 'triggerWootricSurvey'
      }
    });
  }
};
export default triggerWootricSurvey;